// slice.ts
import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import type { SidePanelCounterType } from './types';

const requestInitialState: SidePanelCounterType = {
  counter: [],
  scheduleWoCountByMarkets: {},
};

const requestSlice = createSlice({
  name: 'sidepanel',
  initialState: requestInitialState,
  reducers,
});

export const { updateSidebarCounter, updateScheduleWoCountByMarkets } = requestSlice.actions;

export default requestSlice.reducer;
